import React from 'react'
import Label from 'src/components/riders/rider-portal/common/Label'
import CheckMarker from 'src/components/icons/ui/CheckMarker'
import MapPin from 'src/components/icons/ui/MapPin'
import { IActiveTripResponseV2 } from 'src/types'
import { RIDER_PORTAL_UI_MESSAGES } from 'src/constants/rider-portal'

interface ISuccessBookingConfirmation {
  successBookingDetails: IActiveTripResponseV2 | null
}

const SuccessBookingConfirmation = ({ successBookingDetails }: ISuccessBookingConfirmation) => {
  const { dropoffLocation = '', pickupLocation = '', tripCode = '', service = { name: '' } } =
    successBookingDetails || {}
  const serviceName = service.name ? service.name : 'trip'
  const { trips } = RIDER_PORTAL_UI_MESSAGES

  return (
    <>
      <div className='flex justify-center rp-mb24'>
        <div className='flex items-center justify-center rp-check-icon-wrapper'>
          <CheckMarker className='svg-color-green1 icon--28x28' />
        </div>
      </div>
      <h2 className='font-black1 rp-mb16 mt0 text-center text-2xl'>{`${trips.bookingConfirmed}!`}</h2>
      <p className='font-black1 mt0 rp-mb24 text-center text-md'>{`Your ${serviceName} has been booked successfully.`}</p>
      <div className='rp-booking-details-container rp-mb24'>
        <div className='flex justify-between rp-booking-details'>
          <Label text={trips.bookingReference} />
          <h4 className='font-black1 font-medium my0 text-md'>{tripCode}</h4>
        </div>
        <div className='flex column-gap-12 rp-booking-details rp-pt16'>
          <div className='icon--20x20'>
            <MapPin className='icon--20x20 svg-color-green1' />
          </div>
          <div>
            <h4 className='font-black1 font-medium my0 text-md'>{trips.pickupLocation}</h4>
            <p className='font-black1 mt0 rp-mb0 rp-mt8 text-md'>{pickupLocation && pickupLocation.fullAddress}</p>
          </div>
        </div>
        <div className='flex column-gap-12 rp-pt16'>
          <div className='icon--20x20'>
            <MapPin className='icon--20x20 svg-color-red1' />
          </div>
          <div>
            <h4 className='font-black1 font-medium my0 text-md'>{trips.destination}</h4>
            <p className='font-black1 mt0 rp-mb0 rp-mt8 text-md'>{dropoffLocation && dropoffLocation.fullAddress}</p>
          </div>
        </div>
      </div>
    </>
  )
}

export default SuccessBookingConfirmation



// WEBPACK FOOTER //
// ./src/components/riders/rider-portal/trips/create/Step4/SuccessBookingConfirmation.tsx